
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22.6","viewBox":"0 0 22 22.6"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"-110.727","y1":"134.375","x2":"-109.727","y2":"134.375","gradientTransform":"matrix(21.9989 0 0 -22.6342 2435.87 3052.787)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#eb5c2b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#da1c5c"}})]),_c('path',{attrs:{"fill":"url(#a)","d":"M21.3 15.4c.4-.5.7-1.2.7-1.9 0-.6-.2-1.2-.6-1.6.5-1 .2-2.2-.6-2.9-1.1-.8-2.5-1.1-3.8-.9-.8 0-1.6.1-2.3.3-.2 0-.5.1-.7.2 0-.9.2-1.9.6-2.8.7-2 .6-3.6-.1-4.6C13.8.4 12.9 0 12 0c-.4 0-.7.1-.9.4-.4.7-.6 1.5-.4 2.3-.7 1.6-2.4 5.8-3.9 6.9 0 0-.1 0-.1.1-.4.4-.7.9-.9 1.4-.3-.2-.6-.2-.9-.2H2c-1.1 0-2 .9-2 2v7.7c0 1.1.9 2 2 2h2.9c.4 0 .8-.1 1.1-.4l1.1.1c2.1.3 4.2.4 6.3.3.6 0 1.1.1 1.6.1.7 0 1.5-.1 2.2-.2 1.2-.1 2.3-.8 2.9-1.8.3-.6.4-1.2.3-1.8.7-.6 1.1-1.5 1.1-2.5 0-.4 0-.7-.2-1zM2 21.2c-.4 0-.7-.3-.7-.7v-7.7c0-.4.3-.7.7-.7h2.9c.4 0 .7.3.7.7v7.7c0 .4-.3.7-.7.7H2zm18.1-6.4c-.2.2-.2.5-.1.8.1.2.2.5.2.8 0 .7-.3 1.3-.9 1.6-.2.2-.3.5-.2.7.1.4.1.8-.1 1.2-.5.7-1.3 1.1-2.1 1.2-1.1.2-2.3.2-3.5.1h-.1c-2.1 0-4.1-.1-6.2-.3l-.5-.1v-8.1c0-.2 0-.4-.1-.6.2-.6.5-1.2.9-1.6 2.1-1.7 4.2-7.4 4.3-7.6v-.3c-.1-.5-.1-.9.1-1.4.5 0 1 .2 1.3.6.5.7.5 1.9-.1 3.4-.5 2.5-.6 3.8 0 4.4.3.2.7.3 1 .2.3-.1.6-.1.8-.2h.1c1.5-.3 4.1-.5 5 .3.5.5.5 1.2.2 1.7-.2.3-.1.6.1.8.3.3.5.7.5 1.1 0 .5-.2 1-.6 1.3z"}})])
          )
        }
      }
    